export const types = {
  analysis: 'Análise de conta',
  payment: 'Pagamento',
};

export const paymentTypes = {
  1: 'Inicial',
  2: 'Recurso',
};

export function getName(value) {
  return types[value] || value;
}

export function getPaymentTypeName(value) {
  return paymentTypes[String(Number(value) || 1)] || value;
}
